import React from "react";
import PulseSelectButton from "../../PulseSelectButton/PulseSelectButton";

interface Step4ConfigurationPropsReactNative {
  os: string;
  onUpdateState: (field: "os", value: string) => void;
}

const Step4ConfigurationReactNative: React.FC<
  Step4ConfigurationPropsReactNative
> = ({ os, onUpdateState }) => {
  return (
    <>
      <h1 className="pl-heading-xl">Install SDK</h1>
      <div className="step-content">
        <div className="select-group">
          <h2 className="pl-heading-s">What platform will you be using?</h2>
          <div className="side-by-side-buttons">
            <PulseSelectButton
              options={[
                { label: "Android", value: "android" },
                { label: "iOS", value: "ios" },
              ]}
              value={os}
              onChange={(value) => onUpdateState("os", value)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Step4ConfigurationReactNative;
